const sendReceiptEmail = async (recipientEmail, orderDetails) => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:4000';

    const response = await fetch(`${backendUrl}/api/email/send-receipt`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ recipientEmail, orderDetails }),
    });

    const result = await response.json();

    if (result.success) {
      return { success: true };
    } else {
      console.error('Failed to send email:', result.error);
      return { success: false, error: result.error };
    }
  } catch (error) {
    console.error('Error sending email:', error);
    return { success: false, error: error.message };
  }
};

export { sendReceiptEmail };
